import styled from 'styled-components'

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 16px;
  }
`;

export const SectionsList = styled.div`
  background-color: ${props => props.theme.colors.inputBackground};
  border-radius: 8px;
  height: fit-content;
  padding: 16px;
  min-height: 170px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    display: flex;
    flex-direction: column;
  }
`;

export const CardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  
  >div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    justify-content: start;

    >p, >span {
      margin-bottom: 8px;
    }
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    justify-content: space-between;
    width: 100%;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
`;